import Request from "./request";
import Params from "./params";

let controllerName = (() => {
  return window.location.pathname.split("/")[1];
})();
//localStorage.clear();
let controllerID = null;

const baseURL = Params.apiOrder;
const verifyServer = Params.verificationServer;
const tokenAcces = Params.tokenAccess;
const menuUrl = Params.apiMenu;
//const verifyServer = `http://localhost:8081`;

let cachedTag = localStorage.getItem(controllerName);
let tag = cachedTag ? JSON.parse(cachedTag).tag : null;

const API = {
  // this function will check everytime an api is called to set the controllerID
  // because this is an object initiated at different places of the application
  // not really good but too late to change.
  getDomainUrl: () => {
    //// console.log(controllerID,'controllerID');
    // API.checkControllerId();
    let apiServer = localStorage.getItem(`${controllerID}_apiserver`);
    // console.log(`${controllerID}_apiserver`,apiServer);
    if (
      apiServer !== null &&
      apiServer !== "" &&
      apiServer !== "undefined" &&
      apiServer !== undefined
    ) {
      if (apiServer.charAt(apiServer.length - 1) === "/") {
        apiServer = apiServer.slice(0, -1);
      }
      //request = `${apiServer}/add/${controllerID}?returnHTML=0&tag=${tag}`;
    } else {
      apiServer = baseURL + "/online";
    }

    return apiServer;
  },
  checkControllerId: () => {
    if (controllerID === null) {
      controllerID = localStorage.getItem(`${controllerName}_id`);

      cachedTag = localStorage.getItem(controllerName);
      tag = cachedTag ? JSON.parse(cachedTag).tag : null;
    }
  },
  getMenu: (isCached) => {
    const endpoint = `${menuUrl}/menu/2api/${controllerName}/true/${isCached}/2`;
    //const endpoint = `https://www.foodzaps.com/v10_mobile_staging/menu/2api/${controllerName}/true/${isCached}/2`;
    //const endpoint = `https://onlineordering-env-29zy38zqgq.foodzaps.com/menu/2api/${controllerName}/true/${isCached}/2`;
    //const endpoint = `http://localhost:8081/menu/2api/${controllerName}/true/${isCached}/2`;
    //const endpoint = `https://inruo.serveo.net/menu`;
    // return Request.get(endpoint);
    return Request.getGZipApi(endpoint);
  },
  prepareOrderRequest: (payload) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let request =
      serverUrl +
      `/createOrder/${controllerID}?accessToken=` +
      tokenAcces +
      `&type=web&returnHTML=0&tag=${tag}`;
    request += `${payload}`;
    return Request.get(request);
  },
  
  // Alternative method using POST to avoid long URLs
  prepareOrderRequestPost: (payload) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let requestUrl = serverUrl + `/createOrder/${controllerID}`;
    
    // Keep base parameters in URL
    requestUrl += `?accessToken=${tokenAcces}&type=web&returnHTML=0&tag=${tag}`;
    
    // Send payload data in POST body as URL-encoded string
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    
    // Remove leading '&' if present in payload
    const bodyData = payload.startsWith('&') ? payload.substring(1) : payload;
    
    return Request.post(requestUrl, bodyData, headers);
  },
  calculateTaxs: (orderId) => {
    API.checkControllerId();
    // check if order is successful
    // if no success in json response = pending order
    //const request = `${baseURL}/v13_mobile/online/getOrderStatus/${controllerID}/${orderId}?accessToken=foodzaps`;
    let serverUrl = API.getDomainUrl();
    const request =
      serverUrl +
      `/getOrderStatus/${controllerID}/${orderId}?accessToken=` +
      tokenAcces;
    return Request.get(request);
  },
  createOrder: (payload, verificationCode) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let request =
      serverUrl + `/add/${controllerID}?returnHTML=0&type=web&tag=${tag}`;

    if (
      payload.indexOf("payment=") !== -1 &&
      payload.indexOf('"method":"cash"') === -1
    ) {
      let serverUrl1 = API.getPaymentServerUrl();
      request = `${serverUrl1}verify/add/${controllerID}?returnHTML=0&type=web&tag=${tag}&serverUrl=${encodeURIComponent(
        serverUrl
      )}`;
    }
    if (verificationCode) request += `&verify=${verificationCode}`;

    request += `${payload}`;
    return Request.get(request);
  },

  // POST version of createOrder to avoid long URLs
  createOrderPost: (payload, verificationCode) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let requestUrl = serverUrl + `/add/${controllerID}`;

    if (
      payload.indexOf("payment=") !== -1 &&
      payload.indexOf('"method":"cash"') === -1
    ) {
      let serverUrl1 = API.getPaymentServerUrl();
      requestUrl = `${serverUrl1}verify/add/${controllerID}`;
      
      // Add serverUrl to query params for payment verification
      requestUrl += `?returnHTML=0&type=web&tag=${tag}&serverUrl=${encodeURIComponent(serverUrl)}`;
    } else {
      requestUrl += `?returnHTML=0&type=web&tag=${tag}`;
    }
    
    if (verificationCode) requestUrl += `&verify=${verificationCode}`;

    // Send payload in POST body
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    
    const bodyData = payload.startsWith('&') ? payload.substring(1) : payload;
    
    return Request.post(requestUrl, bodyData, headers);
  },

  // Smart method that chooses GET or POST based on payload length
  createOrderOptimized: (payload, verificationCode) => {
    const maxGetLength = 2000;
    
    if (payload.length > maxGetLength) {
      //console.log(`Payload too long (${payload.length} chars), using POST for createOrder`);
      return API.createOrderPost(payload, verificationCode);
    } else {
      //console.log(`Payload length OK (${payload.length} chars), using GET for createOrder`);
      return API.createOrder(payload, verificationCode);
    }
  },

  // Fire-and-forget order creation - don't wait for response
  createOrderAsync: (payload, verificationCode) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let request =
      serverUrl + `/add/${controllerID}?returnHTML=0&type=web&tag=${tag}`;

    if (
      payload.indexOf("payment=") !== -1 &&
      payload.indexOf('"method":"cash"') === -1
    ) {
      let serverUrl1 = API.getPaymentServerUrl();
      request = `${serverUrl1}verify/add/${controllerID}?returnHTML=0&type=web&tag=${tag}&serverUrl=${encodeURIComponent(
        serverUrl
      )}`;
    }
    if (verificationCode) request += `&verify=${verificationCode}`;

    request += `${payload}`;
    
    // Send request without waiting for response
    console.log('🚀 Sending order request (fire-and-forget):', request);
    
    // Use XMLHttpRequest for fire-and-forget
    const xhr = new XMLHttpRequest();
    xhr.open('GET', request, true);
    xhr.timeout = 5000; // 5 second timeout
    
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          console.log('✅ Order request sent successfully (async)');
        } else {
          console.log('⚠️ Order request sent but got status:', xhr.status);
        }
      }
    };
    
    xhr.onerror = function() {
      console.log('❌ Order request failed to send (async)');
    };
    
    xhr.ontimeout = function() {
      console.log('⏰ Order request timeout (async)');
    };
    
    xhr.send();
    
    // Return immediately with a promise that resolves quickly
    return Promise.resolve({
      status: 'sent',
      message: 'Order request sent asynchronously',
      timestamp: new Date().toISOString()
    });
  },
  checkOrder: (payload, verificationCode) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let request =
      serverUrl +
      `/verifyOrder/${controllerID}?accessToken=` +
      tokenAcces +
      `&returnHTML=0&tag=${tag}`;
    if (verificationCode) request += `&verify=${verificationCode}`;
    request += `${payload}`;
    return Request.get(request);
  },
  checkOrderStatus: (url) => {
    return Request.get(url);
  },
  changeTableCallApi: (payload) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let request =
      serverUrl +
      `/transferOrder/${controllerID}?accessToken=` +
      tokenAcces +
      `&returnHTML=0&tag=${tag}`;
    request += `${payload}`;
    return Request.get(request);
  },
  requestBillNewApi: (msg) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    const requestUrl = serverUrl + `/bill/${controllerID}`;
    return Request.post(
      requestUrl,
      `accessToken=` +
        tokenAcces +
        `&returnHTML=0&tag=${tag}&order=${encodeURIComponent(msg)}`
    );
  },
  addOrderByPost: (suburl, payload) => {
    API.checkControllerId();
    let serverUrl = API.getPaymentServerUrl();
    const requestUrl = serverUrl + suburl;
    // const requestUrl = `http://localhost:8081/`+suburl;
    //// console.log(requestUrl);
    return Request.post(
      requestUrl,
      `accessToken=` + tokenAcces + `&returnHTML=0&tag=${tag}&` + payload
    );
  },
  getOrder: (orderId) => {
    API.checkControllerId();
    // check if order is successful
    // if no success in json response = pending order
    let serverUrl = API.getDomainUrl();
    const request = serverUrl + `/get/${controllerID}/${orderId}?act=test`;

    return Request.get(request);
  },
  
  // Get recent orders for network error recovery
  getRecentOrders: (timeWindow = 5, limit = 10, uuid = null, receiptId = null) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let params = `?accessToken=${tokenAcces}&type=web&returnHTML=0&tag=${tag}`;
    
    // Only add timeWindow and limit if they are provided (not null)
    if (timeWindow !== null) params += `&timeWindow=${timeWindow}`;
    if (limit !== null) params += `&limit=${limit}`;
    
    if (uuid) params += `&uuid=${uuid}`;
    if (receiptId) params += `&receipt_id=${receiptId}`;
    
    const request = serverUrl + `/getRecentOrders/${controllerID}${params}`;
    return Request.get(request);
  },

  // Get specific order by UUID for network error recovery
  getOrderByUuid: (uuid, receiptId = null) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let params = `?accessToken=${tokenAcces}&type=web&returnHTML=0&tag=${tag}&uuid=${uuid}`;
    
    if (receiptId) params += `&receipt_id=${receiptId}`;
    
    const request = serverUrl + `/getOrderByUuid/${controllerID}${params}`;
    return Request.get(request);
  },

  // Get real UUID from database for the current controller
  getRealUUID: () => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let params = `?accessToken=${tokenAcces}&type=web&returnHTML=0&tag=${tag}`;
    
    const request = serverUrl + `/getRealUUID/${controllerID}${params}`;
    return Request.get(request);
  },

  // Poll order status with exponential backoff
  pollOrderStatus: (orderId, maxAttempts = 10, initialDelay = 2000) => {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      let delay = initialDelay;
      
      const poll = () => {
        attempts++;
        console.log(`🔄 Polling order status (attempt ${attempts}/${maxAttempts}):`, orderId);
        
        API.getOrder(orderId)
          .then((res) => {
            console.log('📋 Poll response:', res);
            
            if (res && res.success !== undefined) {
              // Order found with status
              console.log('✅ Order status found:', res.success ? 'success' : 'pending');
              resolve({
                success: res.success,
                orderId: orderId,
                orderNo: res.orderNo,
                msg: res.msg,
                attempts: attempts,
                final: true
              });
            } else if (res && res.indexOf && res.indexOf("PHP Error") !== -1) {
              // PHP Error - order might not exist yet
              console.log('⚠️ PHP Error in poll - order might not exist yet');
              if (attempts < maxAttempts) {
                setTimeout(poll, delay);
                delay = Math.min(delay * 1.5, 10000); // Exponential backoff, max 10s
              } else {
                console.log('❌ Max polling attempts reached');
                resolve({
                  success: false,
                  orderId: orderId,
                  attempts: attempts,
                  final: true,
                  error: 'Max polling attempts reached'
                });
              }
            } else {
              // Empty response or other error - order might not exist yet
              console.log('📭 Empty response in poll - order might not exist yet');
              if (attempts < maxAttempts) {
                setTimeout(poll, delay);
                delay = Math.min(delay * 1.5, 10000); // Exponential backoff, max 10s
              } else {
                console.log('❌ Max polling attempts reached');
                resolve({
                  success: false,
                  orderId: orderId,
                  attempts: attempts,
                  final: true,
                  error: 'Max polling attempts reached'
                });
              }
            }
          })
          .catch((err) => {
            console.log('❌ Poll error:', err);
            if (attempts < maxAttempts) {
              setTimeout(poll, delay);
              delay = Math.min(delay * 1.5, 10000); // Exponential backoff, max 10s
            } else {
              console.log('❌ Max polling attempts reached');
              resolve({
                success: false,
                orderId: orderId,
                attempts: attempts,
                final: true,
                error: 'Max polling attempts reached'
              });
            }
          });
      };
      
      // Start polling
      poll();
    });
  },
  
  callForWaiter: (msg) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    const request =
      serverUrl +
      `/call/${controllerID}?action=waiter&tag=${tag}&msg=${encodeURIComponent(
        msg
      )}`;

    return Request.get(request);
  },
  callForBill: (msg) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    const request =
      serverUrl +
      `/call/${controllerID}?action=cashier&tag=${tag}&msg=${encodeURIComponent(
        msg
      )}`;

    return Request.get(request);
  },
  sendEmail: (msg) => {
    const request = `${verifyServer}send-email?msg=${encodeURIComponent(msg)}`;
    return Request.get(request);
  },
  getPaymentServerUrl: () => {
    let verifyServerRest = localStorage.getItem(
      `${controllerName}_verifyserver`
    );
    let serverUrl1 = verifyServer;
    if (verifyServerRest) {
      serverUrl1 = verifyServerRest;
    }
    return serverUrl1;
  },
  checkShippingCharge: (url, params) => {
    return Request.postJson(url, params);
  },
  callPostJson: (suburl, params) => {
    API.checkControllerId();
    let serverUrl = API.getPaymentServerUrl();
    const requestUrl = serverUrl + suburl;
    return Request.postJson(requestUrl, params);
  },
  updateSpotOrder: (customOrderId, status, label) => {
    API.checkControllerId();
    let payload = {
      controllerId: controllerID,
      customOrderId: customOrderId,
      status: status,
      message: label + " - Pay at counter after meal",
    };
    if (localStorage.getItem("spotMethod") === "spot") {
      let resp = API.callPostJson("update-spot-order", payload);
// console.log(resp);
    }
  },
  createSpotMessage: (message) => {
    API.checkControllerId();
    let payload = {
      controllerId: controllerID,
      message: {
        ...message,
      },
    };
    if (localStorage.getItem("spotMethod") === "spot") {
      let resp = API.callPostJson("create-spot-message", payload);
// console.log(resp);
    }
  },
  getPingStaus: (pingurl) => {
    return Request.get(pingurl + "?accessToken=foodzaps&type=QR");
  },
  getPingYeahpayStatus: (controller, refId) => {
    return Request.postJson(
      verifyServer + `yeahpay/order?controller=${controller}&sandbox=false`,
      {
        orderId: refId,
      }
    );
  },
  callbackPingYeahpayStatus: (paymentPayload) => {
    return Request.postJson(verifyServer + "yeahpay/callback", paymentPayload);
  },
  requestAddressBasedPostal: (url, params) => {
    return Request.post(url, params);
  },
  /*,
        getIP:() => {    
         // const request = `${baseURL}/get-ip`;
          const request = 'https://api.ipify.org/?format=json';
          return Request.get(request);
        }*/
};

export default API;
